@if (visible()) {
  <div class="fixed inset-0 bg-black/45 flex items-center justify-center z-[99]">
    <div class="flex flex-col gap-2 bg-bg rounded-[32px] w-[460px] p-4">
      <div class="flex flex-col">
        <!-- <app-icon [name]="iconPermission" [size]="80" /> -->
        <img
          [src]="'/assets/icon/' + iconPermission + '.svg'"
          alt="permission icon"
          class="w-20 h-20"
        />
        <div class="flex flex-col gap-1 py-2">
          <span class="font-semibold text-text-primary text-2xl">
            @if (data?.state === 'none') {
              Không thể tìm thấy {{ textPermission }} trên thiết bị của bạn
            } @else {
              Cho phép
              {{
                (data?.type === 'share-screen' ? 'chia sẻ ' : 'truy cập ').concat(textPermission)
              }}
            }
          </span>
          <!-- <span class="text-base text-text-secondary font-normal">{{data.note}}</span> -->
          <span class="text-base text-secondary font-normal">
            @if (data?.state === 'none') {
              Hãy thử kết nối {{ textPermission }} hoặc nếu đã kết nối thì hãy thử khởi động lại
              trình duyệt.
            } @else if (data?.state === 'denied') {
              Tammi cần truy cập {{ textPermission }} để bạn có thể
              {{ descriptionPermission }}
            } @else if (data?.state === 'browser-blocked') {
              <div class="screen-permission-guide">
                <h3>Hướng dẫn cấp quyền {{ textPermission }}</h3>
                <ol class="list-decimal list-inside">
                  <li>
                    Truy cập vào <strong>Cài đặt hệ thống</strong> &gt;
                    <strong>Quyền riêng tư &amp; Bảo mật</strong> &gt;
                    <strong class="capitalize">{{ textPermission }}</strong>
                  </li>
                  <li>
                    Bật quyền <strong>{{ textPermission }}</strong> cho trình duyệt bạn đang sử dụng
                  </li>
                  <li>Tải lại trang và thử lại</li>
                </ol>
              </div>
            } @else if (data?.state === 'safari-blocked') {
              Trong trình duyệt Safari, hãy chọn "Settings for tammi.vn..." rồi cập nhật chế độ "{{
                textPermission
              }}" thành "Ask"
            }
          </span>
        </div>
      </div>
      <div class="pt-4 flex justify-between gap-2">
        @if (data?.state === 'none' || data?.state === 'safari-blocked') {
          <button
            class="flex-1 app-button app-button__secondary py-2 px-3 h-12 text-base font-semibold flex items-center justify-center"
            (click)="close()"
          >
            Đã hiểu
          </button>
        } @else {
          <button
            class="flex-1 app-button app-button__solid-secondary py-2 px-3 h-12 text-base font-semibold"
            (keydown.enter)="close()"
            (click)="close()"
          >
            Bỏ qua
          </button>
          @if (data?.state === 'denied') {
            <usermedia
              class="pepc-permission-dialog__permission-button flex-1 app-button app-button__secondary py-2 px-3 h-12 font-base"
              [type]="data?.type === 'mic' ? 'microphone' : 'camera'"
              tabindex="0"
            >
              Cho phép
            </usermedia>
          } @else {
            <button
              class="flex-1 app-button app-button__secondary py-2 px-3 h-12 text-base font-semibold flex items-center justify-center"
              (click)="openSetting()"
            >
              Mở cài đặt
            </button>
          }
        }
      </div>
    </div>
  </div>
}
